import styled from '@emotion/styled'

export const ShowMoreButtonWrapper = styled.div`
  display: flex;
  padding-top: 10px;

  /* Кнопка обёрнута в Ant-Spin (.ant-spin-nested-loading/.ant-spin-container),
     поэтому width:100% только на кнопке даёт 100% от узкой спин-обёртки.
     Растягиваем и прямого ребёнка (спин), и саму кнопку на всю ширину плашки. */
  & > *,
  & button {
    width: 100%;
  }
`
